import { kCloudAuthenticateApi } from "@/features/accounts/account-group/services/kcloud-authenticate-api";
import type { KCloudLoginRequest, KCloudLoginResponse, ClientSyncRequest } from "@/features/accounts/account-group/services/kcloud-authenticate-model";

export class KCloudAuthenticateService {
  static async login(service: "kaikei" | "shokokai", request: KCloudLoginRequest): Promise<KCloudLoginResponse> {
    return await kCloudAuthenticateApi.login(service, request);
  }

  static async selectClient(service: "kaikei" | "shokokai", request: ClientSyncRequest): Promise<void> {
    return await kCloudAuthenticateApi.selectClient(service, request);
  }
}
